import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { _grpcMsmLifecycleDelete, createSitelessMetaSite, readApiGet } from '@wix/ambassador-metasite-api-v1-meta-site/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { MetasiteClientBase } from './MetasiteClientBase';
export class MetasiteClient extends HttpBaseClient(MetasiteClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createSitelessMetaSiteImpl", createSitelessMetaSite);
    _defineProperty(this, "deleteMetaSiteImpl", _grpcMsmLifecycleDelete);
    _defineProperty(this, "readApiGetImpl", readApiGet);
  }
  async search(_request) {
    // Note: search doesn't have an HTTP equivalent in the ambassador package
    // This would need to be implemented using direct HTTP calls if needed
    throw new Error('search is not supported in HTTP mode. Use RPC mode instead.');
  }
  async getClientSpecMap(_metaSiteId, _aspects) {
    // Note: getClientSpecMap doesn't have an HTTP equivalent in the ambassador package
    // This could potentially use a public endpoint similar to getVisitorSignedInstance
    // For now, throwing an error - can be implemented later if needed
    throw new Error('getClientSpecMap is not supported in HTTP mode. Use RPC mode instead.');
  }
  async getOwnerId(metaSiteId, _aspects) {
    // Note: readApiGet for HTTP gets metaSiteId from the signed identity in aspects
    // However, HttpBaseClient's request method doesn't accept aspects parameter
    // For HTTP, aspects are typically handled through the HTTP client configuration
    // This implementation assumes the HTTP client is configured with the proper signed identity
    // If aspects need to be passed, the HTTP client would need to be updated to support it
    try {
      this.logInfo('getOwnerId', 'entry', {
        metaSiteId
      });

      // HTTP request doesn't accept aspects - they should be in the HTTP client config
      // readApiGet will get metaSiteId from the request context/headers
      const {
        metaSite
      } = await this.request(this.readApiGetImpl({}));
      if (!(metaSite != null && metaSite.ownerId)) {
        this.logError('getOwnerId', 'failed to get metasite ownerId', {
          metaSiteId
        });
        throw new Error('Error getting ownerId');
      }
      return metaSite.ownerId;
    } catch (error) {
      this.logError('getOwnerId', 'Failed to get owner ID', {
        metaSiteId
      }, error);
      throw error;
    }
  }
  async getVisitorSignedInstance(appId, metaSiteId) {
    try {
      this.logInfo('getVisitorSignedInstance', 'entry', {
        metaSiteId
      });
      const {
        data: clientSpecMap
      } = await this.client.request({
        method: 'GET',
        url: `/_api/public-csm-server/v1/client-spec-map/public/${metaSiteId}`
      });
      this.logInfo('getVisitorSignedInstance', 'visitor clientSpecMap', {
        clientSpecMap
      });
      if (!clientSpecMap) {
        throw new Error('Error getting client spec map');
      }
      const {
        instance
      } = Object.values(clientSpecMap).find(spec => spec.appDefinitionId === appId) || {};
      this.logInfo('getVisitorSignedInstance', 'instance', {
        instance
      });
      if (!instance) {
        throw new Error('Error getting signed instance');
      }
      return instance;
    } catch (error) {
      this.logError('getVisitorSignedInstance', 'Failed to get visitor signed instance', {
        appId,
        metaSiteId
      }, error);
      throw error;
    }
  }
}
//# sourceMappingURL=MetasiteClientHttp.js.map